import { createSlice, current } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
};

const drawerSlice = createSlice({
  name: "drawer",
  initialState,
  reducers: {
    toggleDrawer(state, action) {
      state.isOpen = !current(state).isOpen;
    },
  },
});

export const { toggleDrawer } = drawerSlice.actions;
export default drawerSlice.reducer;
